import React, { useEffect, useState } from "react";
import "../Assets/Css/Teachers.css";
import prevArrow from "../Assets/Images/Dashboard/prev_icon.png";
import nextArrow from "../Assets/Images/Dashboard/next_icon.png";

import upArrow from "../Assets/Images/Dashboard/up_arrow.png";
import downArrow from "../Assets/Images/Dashboard/down_arrow.png";
import profile_pic from "../Assets/Images/Dashboard/default_profile.svg";

import Sidebar from "../Component/Sidebar";
import Loader from "../Component/Loader";
// import TeacherTransferIcon from "../Assets/Images/Sidebar/teacher_transfer_icon.svg";
import { Link, useLocation } from "react-router-dom";

import ExportToExcel from "./ExportToExcel";
import { toast, ToastContainer } from "react-toastify";

const SchoolBestPerformingTrainerList = () => {
  const itemsPerPage = 10;
  const [token, setToken] = useState(localStorage.getItem("authToken"));
  const [userRole, setUserRole] = useState(localStorage.getItem("user_role"));

  const [isLoading, setIsLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const location = useLocation();

  const { school_id, schoolDetails, principalName, referrer } =
    location.state || "";
  const [user, setUser] = useState(schoolDetails?schoolDetails?.trainers:[]);
  // console.log("state: ", location.state);

  useEffect(() => {
    // Store referrer in localStorage for Sidebar
    localStorage.setItem("referrer", referrer);

    // Clear referrer on unmount
    return () => {
      localStorage.removeItem("referrer");
    };
  }, [referrer]);
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
    // fetchData();
  };

  const handleSort = (key) => {
    if (sortKey === key) {
      // If already sorted by this key, toggle the order
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // If sorting by a new key, set it and default to ascending order
      setSortKey(key);
      setSortOrder("asc");
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const filteredUsers = user.filter((userData) => {
    const query = searchQuery.toLowerCase();
    return (
      (userData.tra_name && userData.tra_name.toLowerCase().includes(query)) ||
      (userData.tra_phone && userData.tra_phone.includes(query))
    );
  });

  const paginatedUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  const sortedUsers = sortKey
    ? paginatedUsers.sort((a, b) => {
        // Sort function based on the current sort key and order
        const aValue = String(a[sortKey]).toLowerCase();
        const bValue = String(b[sortKey]).toLowerCase();
        if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
        if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
        return 0;
      })
    : paginatedUsers;

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const totalItems = filteredUsers.length;
  const PagePerItem = Math.min(totalItems - indexOfFirstItem, indexOfLastItem);
  const rangeStart = Math.min((currentPage - 1) * itemsPerPage + 1, totalItems);
  const rangeEnd = Math.min(currentPage * itemsPerPage, totalItems);
  return (
    <>
      <Sidebar />
      
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <section className="schoolListSection">
            <div className="sidebody">
              <div className="container">
                {/* Your main_div */}
                <div className="main_div">
                  <div
                    className="schListHeader_div"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {/* Your header_text and search_div */}
                    <div>
                      {/* <p>Teachers</p> */}

                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                          <Link
                            to="/school-dashboard"
                            className="prevPage"
                            state={{
                              school_id: school_id,
                              schoolDetails: schoolDetails,
                              principalName: principalName,
                              referrer: referrer,
                            }}
                          >
                            {principalName
                              ? principalName
                              : schoolDetails.princi_name}
                          </Link>
                          <img
                            src={nextArrow}
                            alt="nextArrow"
                            height={40}
                            className="mt-1"
                          />
                          <p className="currentPage">Teachers</p>
                        </ol>
                      </nav>
                    </div>
                    <div className="d-flex">
                      <div>
                        <ExportToExcel
                          data={user}
                          fileName="Schools_Teacher_List"
                          sheetName="Teachers"
                          columns={[
                            { key: "tra_name", alias: "Teacher Name" },
                            { key: "tra_phone", alias: "Phone Number" },
                            { key: "tra_email", alias: "Email" },
                            { key: "tra_address", alias: "Address" },
                            { key: "tra_qualification", alias: "Qualification" },
                          ]}
                        />
                      </div>
                      <div className="searchBar" style={{ marginTop: "5px" }}>
                        <form className="d-flex">
                          <input
                            className="form-control me-2"
                            type="search"
                            placeholder="Search"
                            aria-label="Search"
                            onChange={handleSearch}
                            style={{ borderRadius: "12px", border: "none" }}
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                  {/* Your content table-responsive */}
                  {sortedUsers?.length < 0 || sortedUsers?.length === 0 ? (
                    <>
                      <p className="progressMainTitle text-center">
                        No data available
                      </p>
                    </>
                  ) : (
                    <div
                      className="card schoolListTableDiv"
                      style={{ border: "none" }}
                    >
                      <div
                        className=" table-responsive  card-body"
                        style={{ maxHeight: "750px" }}
                      >
                        <table className="table table-borderless table-responsive">
                          <thead
                            style={{ marginBottom: "20px" }}
                            className="thead_div"
                          >
                            <tr>
                              <th
                                style={{ width: "8%" }}
                                className="thead_div_row pb-4"
                              >
                                Sr. No
                              </th>
                              <th
                                scope="col"
                                // style={{  textAlign: "left" }}
                                className="thead_div_row pb-4"
                              >
                                Teacher &nbsp;
                                <button
                                  className="sort_button"
                                  onClick={() => handleSort("tra_name")}
                                  // style={{marginLeft:"4px"}}
                                >
                                  <img
                                    src={
                                      sortKey === "tra_name" &&
                                      sortOrder === "asc"
                                        ? downArrow
                                        : upArrow
                                    }
                                    className="desc"
                                    style={{ marginRight: "15px" }}
                                    alt="arrows"
                                  />
                                </button>
                              </th>

                              {/* <th
                                scope="col"
                                className="thead_div_row pb-4"
                                style={{ width: "15%" }}
                              >
                                Location{" "}
                              </th> */}
                              <th scope="col" className="thead_div_row pb-4">
                                Teacher Mobile
                              </th>
                              <th scope="col" className="thead_div_row pb-4">
                                Email ID
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortedUsers.map((userData, index) => (
                              <tr key={index}>
                                <td
                                  className="header_srNo"
                                  style={{ paddingBottom: "36px" }}
                                >
                                  {index + indexOfFirstItem + 1}
                                </td>
                                <td className="d-flex">
                                  <Link
                                    to="/teacherParticularData"
                                    style={{ textDecoration: "none" }}
                                    onClick={() => {
                                      localStorage.setItem(
                                        "trainer_id",
                                        userData.tra_id
                                      );
                                      localStorage.setItem(
                                        "trainer_name",
                                        userData.tra_name
                                      );
                                    }}
                                    state={{
                                      trainerId: userData.tra_id,
                                      referrer: "/school-dashboard",
                                    }}
                                  >
                                    <img
                                      src={
                                        userData.tra_image === null ||
                                        userData.tra_image === ""
                                          ? profile_pic
                                          : userData.tra_image
                                      }
                                      style={{
                                        width: "24px",
                                        height: "24px",
                                      }}
                                      onError={(e) => {
                                        e.target.src = profile_pic;
                                      }}
                                      alt="profilePic"
                                    />

                                    <span className="allocatedTeacher ms-2">
                                      {userData.tra_name}
                                    </span>
                                  </Link>
                                </td>

                                {/* <td className="location_text">
                                 
                                  {userData.tra_address}
                                </td> */}
                                <td className="teacher_mobile">
                                  {userData.tra_phone
                                    ? userData.tra_phone
                                    : "-"}
                                </td>
                                <td className="teacher_mobile">
                                  {userData.tra_email
                                    ? userData.tra_email
                                    : "-"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div
                        className="footer card-footer"
                        style={{ marginTop: "12px" }}
                      >
                        <div className="row">
                          {
                            <div className="result_msg_text col-lg-7 col-sm-7 sol-12">
                              Displaying {rangeEnd} results of {totalItems}
                            </div>
                          }
                          <div className="button_module col-12 col-lg-5 col-sm-5 col-md-5 d-flex ">
                            <div
                              className="dropdown d-flex"
                              style={{
                                alignItems: "center",
                                marginRight: "10px",
                              }}
                            >
                              <p className="paginate_msg_text">Page</p>
                              <select
                                value={currentPage}
                                onChange={(e) =>
                                  setCurrentPage(Number(e.target.value))
                                }
                                className="select_page"
                                style={{
                                  marginRight: "8px",
                                  marginLeft: "16px",
                                }}
                              >
                                {Array.from({ length: totalPages }, (_, i) => (
                                  <option key={i + 1} value={i + 1}>
                                    {i + 1}
                                  </option>
                                ))}
                              </select>
                              <span className="paginate_msg_text">
                                of {totalPages}
                              </span>
                            </div>
                            <div className="d-flex">
                              <button
                                type="button"
                                className="bton"
                                onClick={prevPage}
                                disabled={currentPage === 1}
                              >
                                <img
                                  src={prevArrow}
                                  alt="prev"
                                  className="arrow_btn"
                                />
                              </button>

                              <button
                                type="button"
                                className="bton"
                                onClick={nextPage}
                                disabled={currentPage === totalPages}
                              >
                                <img
                                  src={nextArrow}
                                  alt="next"
                                  className="arrow_btn"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default SchoolBestPerformingTrainerList;
